import WorkQuestionDialog from '@/components/base_components/dialog/icon-dialogs/WorkQuestionDialog';
import WorkInformationDialog from '@/components/base_components/dialog/icon-dialogs/WorkInformationDialog';
import WorkWarningDialog from '@/components/base_components/dialog/icon-dialogs/WorkWarningDialog';
import CONFIRMATION_DESCRIPTION_TYPES from '@/static-enums/CONFIRMATION_DESCRIPTION_TYPES';

const getComponentByDescriptionType = (type) => {
  switch (type) {
      case CONFIRMATION_DESCRIPTION_TYPES.WARN:
        return WorkWarningDialog;
      case CONFIRMATION_DESCRIPTION_TYPES.INFO:
        return WorkInformationDialog;
      default:
        return WorkQuestionDialog;
    }
}

export { getComponentByDescriptionType }
